import { icons, type LucideProps } from 'lucide-react';

interface LucideIconProps extends LucideProps {
  /** Lucide icon name, e.g. "Package", "BarChart2", "ShieldCheck" */
  name: string;
}

/**
 * Renders a Lucide icon by name. Falls back to a generic square if the
 * name doesn't match any known icon.
 */
export default function LucideIcon({ name, ...props }: LucideIconProps) {
  const Icon = icons[name as keyof typeof icons];

  if (!Icon) {
    // Fallback: render a simple placeholder so the UI never breaks
    const FallbackIcon = icons['Square'];
    return FallbackIcon ? <FallbackIcon {...props} /> : null;
  }

  return <Icon {...props} />;
}
